import Radio from '../../../../Components/Radio/Radio'
import './PaymentTypeView.css'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import { useContext, useEffect, useState } from 'react'
import Plan from '../../Models/Plan'
import PlanLayout from '../../Layouts/PlanLayout/PlanLayout'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import PaymentType from '../../Models/PaymentType'
import API from '../../Services/API'
import { ProductCategory } from '../../Enums/ProductCategory'

const PaymentTypeView = () => {
	let context = useContext(ConfiguratorContext)

	let [plan, setPlan] = useState<Plan | undefined>(undefined)
	let [paymentTypes, setPaymentTypes] = useState<PaymentType[]>([])
	let [selectedType, setSelectedType] = useState<PaymentType | undefined>(context.paymentType)
	let [selectionError, setSelectionError] = useState("")

	context.validatePaymentTypeView = async () => {
		context.paymentType = selectedType
		let validSelection = selectedType !== undefined
			&& (paymentTypes.find(x => x.id == selectedType!.id)) !== undefined
		setSelectionError(validSelection ? "" : "E' necessario selezionare un tipo di pagamento")


		if (validSelection) {
			let res = await createContract()
			if (!res) {
				setSelectionError(validSelection ? "" : "Errore durante la creazione del contratto")
				return false
			}
		}

		return validSelection
	}

	useEffect(() => {
		(async () => {
			let response = await API.getPaymentTypes(context.isHomeUse ? 1 : 2, context.paymentMode!.id)
			if (response.success) {
				setPaymentTypes(response.data)
			}
		})()
		return () => { }
	}, [])

	useEffect(() => {
		(async () => {
			if (context.paymentType === undefined && paymentTypes.length === 1) {
				setSelectedType(paymentTypes[0])
			}
		})()
		return () => { }
	}, [paymentTypes])

	useEffect(() => {
		context.paymentType = selectedType
		return () => { }
	}, [selectedType])

	var selectionChanged = context.options?.flatMap(x => [...x.selection].sort((a, b) => a[0] - b[0]).map(x => x[1])).join("")

	useEffect(() => {
		(async () => {
			let m = []
			for (var d of context.options ?? []) {
				m.push({ id: d.parentId, products: [...d.selection].filter(x => x[1]).map(x => x[0]) })
			}
			let p = await API.getPlanAsync(context.selectedOffer!.id, {
				number_portability: context.keepNumber,
				wifi_consultancy: context.wifiCoverageCheck,
				payment_type: context.paymentType != null ? context.paymentType.name : '',
				payment_mode: context.paymentMode != undefined ? context.paymentMode.name : '',
				customer_type_id: context.isHomeUse ? 1 : 2,
				data: m
			})
			if (p.success) {
				setPlan(p.data)
			}
		})()
		return () => { }
	}, [context.keepNumber, context.paymentType, context.wifiCoverageCheck, context.selectedOffer, context.options, selectionChanged, selectedType])

	async function createContract() {
		let res = await API.createContractAsync(
			{
				customer_id: context.customerId!,
				status: "pending",
				content: createContractContent(),
				package_id: context.selectedOffer!.id
			}
		)
		if (res.success) {
			context.contractId = res.data.id
		}
		return res.success
	}

	function createContractContent(): any {
		let content = {
			"connectionService": {
				"name": context.selectedOffer!.name,
				"description": context.selectedOffer!.description,
				"price": '€ ' + getDiscountedPrice(context.selectedOffer!.price, context.paymentMode!.percentage_discount),
			},
			"activationServices": [],
			"additionalServices": [],
			"options": [],
			"installationServices": getInstallationServicesArray(),
			"recession": getRecessionArray(),
			"paymentMode": {
				"name": context.paymentMode!.description,
				"description": context.paymentMode!.description,
				"type": selectedType!.description,
			},
			"voipSelected": context.voipSelected,
			"currentPhoneNumber1": context.currentPhoneNumber1,
			"currentPhoneNumber2": context.currentPhoneNumber2,
			"currentPhoneNumber3": context.currentPhoneNumber3,
			"currentPhoneNumber4": context.currentPhoneNumber4,
			"inboundCallNumber": context.inboundCallNumber
		}
		attachProductsToContent(content)
		return JSON.stringify(content)
	}

	function getInstallationServicesArray(): any {
		if (context.selectedOffer?.connection_type === 'Wireless') {
			return [
				{
					"name": 'Sopralluogo',
					"description": 'Verifica sul posto della effettiva copertura del servizio, senza utilizzo attrezzature speciali (piattaforma o altro)',
					"price": 'INCLUSO',
				}
			]
		}
		else {
			return []
		}
	}

	function getRecessionArray(): any {
		return [
			{
				"name": 'Standard',
				"description": 'Contributo per le prestazioni di disattivazione(3)',
				"price": '€ 50,00',
			}
		]
	}

	function getFormattedPrice(price: number): string {
		let priceString = price.toFixed(2)
		priceString = priceString.replace('.', ',')
		return priceString.includes(',') ? priceString : priceString + ',00'
	}

	function getDiscountedPrice(price: number, percentageDiscount: number) {
		if (percentageDiscount !== 0) {
			return getFormattedPrice(price - (price / percentageDiscount))
		}
		else {
			return getFormattedPrice(price)
		}

	}

	function attachProductsToContent(content: any): any {
		for (var productSection of context.packageProducts!) {
			for (var product of productSection.products) {
				for (var planProduct of context.planProducts!) {
					if (planProduct.id === product.id
						&& planProduct.label !== context.selectedOffer?.name
					) {
						let productObject =
						{
							"name": product!.name,
							"description": product!.description,
							"price": '€ ' + getFormattedPrice(planProduct!.no_vat_value ?? 0),
						}

						switch (productSection.product_category) {
							case ProductCategory.AdditionalAndOptionalServices:
								content.additionalServices.push(productObject);
								break;
							case ProductCategory.ServiceActivation:
								content.activationServices.push(productObject);
								break;
							case ProductCategory.Options:
								content.options.push(productObject);
								break;
							case ProductCategory.InstallationServices:
								content.installationServices.push(productObject);
								break;
							default:
								break;
						}
					}
				}
			}
		}

		return content
	}

	return (
		<PlanLayout plan={plan}>
			<div className='payment-type-view-container'>
				<div className='payment-type-view-title'>Scegli il tipo di pagamento</div>
				<div className='payment-type-radio-container'>
					{paymentTypes.map(x =>
						<div className='payment-type-radio'>
							<Radio key={x.id} checked={selectedType !== undefined && selectedType.id === x.id} onChange={() => setSelectedType(x)} />
							{x.name}
						</div>
					)}
				</div>
				<div className='label-error'>{selectionError}</div>
			</div>
		</PlanLayout>
	)
}

const PaymentTypeNode: NavigationNode = {
	content: () => <PaymentTypeView />,
	next: (context: Configuration) => context.paymentType?.name.toLowerCase().includes('bonifico') ? ViewType.documentsUpload : ViewType.bankForm,
	previous: (context: Configuration) => ViewType.paymentMode,
	percentage: 90
}

export default PaymentTypeNode